import { useEffect, useState } from "react";
import { Course, days, defaultUrl, grades, sendPostReq } from "../Scripts/misc";
import "../Styles/courseDetailsPage.css"
import { useNavigate, useSearchParams } from "react-router-dom";
import { useFormHandler } from "../Scripts/hooks/useFormHandler";

interface Props {
    token: string
    courses: Course[]
    getCourses: Function
}

function CourseDetailsPage({token, courses, getCourses}: Props) {


    let [selectedCourse, setSelectedCourse] = useState<Course>(courses[0])

    const selectCourseById = (id: number) => {
        const course = (courses.filter(c => {if (c) {return c.id == id} else {return false}}))[0]
            if (course) {
                setSelectedCourse(course)
                let elem = document.getElementById("courseSelect") as HTMLInputElement
                elem.value = String(courses.indexOf(course))
            }
    }

    useEffect(() => {

        window.scrollTo(0,0)

        if (!params.get("courseId") ) {return}
        try {
            const id = Number(params.get("courseId"))
            selectCourseById(id)
        }
        catch (err) {console.log("param id isnt a number")}
            
    },[])



    const printCourseOptions = () => {
        let i = -1;
        return courses.map((c) => {
            i++;
            return <option value={i} key={i}>{c && c?.id + ": " + c.name}</option>
        })
    }

    const selectCourse = async (e: any) => {
        let val = await e.target.value;
        setInputImg(undefined)
        await setSelectedCourse(courses[val]);

        Object.keys(formData).forEach(k => {
            if (!(["token","id"].includes(k))) {
                let elem = document.getElementById(k) as HTMLInputElement
                elem.value = ""
            }
        })
    }

    let {formData, setFormData, formChange} = useFormHandler({
        token: token,
        id: 0,
        name: "",
        description: "",
        minAge: "",
        maxAge: "",
        dayOfWeek: "",
        startTime: "",
        endTime: "",
        capacity: ""
    }, undefined, false)

    const [params, setParams] = useSearchParams();

    useEffect(() => {
        if (selectedCourse) {setFormData({
            token: token,
            id: selectedCourse.id,
            name: selectedCourse.name,
            description: selectedCourse.description,
            minAge: String(selectedCourse.minAge),
            maxAge: String(selectedCourse.maxAge),
            dayOfWeek: String(selectedCourse.dayOfWeek),
            startTime: selectedCourse.startTime,
            endTime: selectedCourse.endTime,
            capacity: String(selectedCourse.capacity)
        })
        let elem = document.getElementById("courseImg") as HTMLImageElement
        if (elem) {elem.src = defaultUrl + selectedCourse.image}
    }
    }, [selectedCourse])

    let [err, setErr] = useState("")

    const saveCourse = async () => {

        setErr("Údaje se nahrávají")

        let res = await sendPostReq("/api/saveCourse", formData)

        await uploadImg(res.data)

        switch(res.data) {
            default:
                setErr("Kroužek se úspěšně uložil")
                getCourses()
                break
        }

    }

    let nav = useNavigate()

    const createCourse = async () => {

        let res = await sendPostReq("/api/saveCourse", {token: token, name: "Nový kroužek"})

        switch(res.data) {
            default:
                await getCourses()
                nav("/editCourse?courseId=" + res.data)
                window.location.reload()
                break
        }

    }

    // Image handling (oh god)


    let [inputImg, setInputImg] = useState(undefined)
    const splitToChunks = (content: any) => {
            var chunkSize = 50000;
            var chunks = [];
            for(var start = 0; start < content.length; start += chunkSize){
                chunks.push(content.slice(start, start+chunkSize));
            }
    
            return chunks
    }

    const getSelectedImg = async () : Promise<{content: any, name: string} | undefined> => {
        return new Promise((resolve, reject) => {let elem = document.getElementById("img") as HTMLInputElement;
        if (elem.files) {
            let reader = new FileReader();

            if (!elem.files[0]) {
                resolve(undefined)
            }

            const fileName = elem.files[0].name

            reader.onload = (e: any) => {
                let imgElem = document.getElementById("courseImg") as HTMLImageElement
                imgElem.src = e.target.result
                resolve({content: e.target.result, name: fileName})
            };

            reader.readAsDataURL(elem.files[0])
        }
        })
    }

    const uploadImg = async (id: string) => {
        const img: {content: any, name: string} | undefined = await getSelectedImg()
        setErr("Obrázek se nahrává, počkejte prosím")

        if (!img) {return}

        const chunks = splitToChunks(img.content)
        for (let i = 0; i < chunks.length; i++) {
            let res = await sendPostReq("/api/uploadFIle", {
                token: token,
                id,
                file: img.name,
                content: chunks[i],
                chunks: chunks.length,
                chunkId: i
            })
        }
    }

    return ( 
        <>
        
        <div className="container-fluid-details mt-5">
        <div className="form-group">
                    <label htmlFor="courseSelect">Kroužek: </label>
                    <select className="form-control" id="courseSelect" name="courseSelect" onChange={selectCourse}>
                        {printCourseOptions()}
                    </select>
                </div>
    <div className="form-group">
        <button className="btn btn-primary" onClick={createCourse}><i className="bi bi-plus-lg"/>Nový kroužek</button>        
        </div>

    <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item">
            <a className="nav-link active" id="edit-details-tab" data-toggle="tab" href="#edit-details" role="tab" aria-controls="edit-details" aria-selected="true">Editovat detaily</a>
        </li>
        <li className="nav-item">
            <a className="nav-link" id="participants-tab" data-toggle="tab" href="#participants" role="tab" aria-controls="participants" aria-selected="false">Účastníci</a>
        </li>
    </ul>
    <div className="tab-content" id="myTabContent">
        <div className="tab-pane fade show active" id="edit-details" role="tabpanel" aria-labelledby="edit-details-tab">
            <h4>Editovat detaily</h4>
            

                <div className="form-group">
                    <label htmlFor="name">Název kroužku</label>
                    <input type="text" className="form-control" id="name" name="name" placeholder={formData.name} onChange={formChange}/>
                </div>

                <div className="form-group">
                    <label htmlFor="description">Popis</label>
                    <textarea className="form-control" id="description" name="description" rows={3} placeholder={formData.description} onChange={formChange}/>
                </div>

                <div className="form-group">
                    <label htmlFor="minAge">Min. věk</label>
                    <select id="minAge" className="form-control" onChange={formChange}>
                        {Object.keys(grades).map(k => {
                            if (formData.minAge == k) {
                                return <option value={k} selected>{grades[k]}</option>
                            } else {
                                return <option value={k}>{grades[k]}</option>
                            }
                        })}
			        </select>
                </div>

                <div className="form-group">
                    <label htmlFor="maxAge">Max. věk</label>
                    <select className="form-control" id="maxAge" onChange={formChange}>
                        {Object.keys(grades).map(k => {
                            if (formData.maxAge == k) {
                                return <option value={k} selected>{grades[k]}</option>
                            } else {
                                return <option value={k}>{grades[k]}</option>
                            }
                        })}
			        </select>
                </div>

                <div className="form-group">
                    <label htmlFor="dayOfWeek">Den v týdnu</label>
                    <select className="form-control" id="dayOfWeek" onChange={formChange}>
                        {(() => {
                             let i = 0;
                             return days.map(d => {
                                i++;
                                if (formData.dayOfWeek == String(i)) {
                                    return <option value={i} selected>{d}</option>
                                } else {
                                    return <option value={i}>{d}</option>
                                }
                             }) 
                        })()}
			        </select>
                </div>

                <div className="form-group">
                    <label htmlFor="startTime">Začátek</label>
                    <input type="text" className="form-control" id="startTime" onChange={formChange} placeholder={String(formData.startTime)} onFocus={(e) => {e.target.type = "time"}} onBlur={(e) => {e.target.type = "text"}}/>
                </div>

                <div className="form-group">
                    <label htmlFor="endTime">Konec</label>
                    <input type="text" className="form-control" id="endTime" onChange={formChange} placeholder={String(formData.endTime)} onFocus={(e) => {e.target.type = "time"}} onBlur={(e) => {e.target.type = "text"}}/>
                </div>

                <div className="form-group">
                    <label htmlFor="capacity">Kapacita</label>
                    <input type="number" className="form-control" id="capacity" name="capacity" placeholder={String(formData.capacity)} onChange={formChange}/>
                </div>

                <div className="form-group">
                    <label htmlFor="image">Obrázek (pouze JPG a PNG)</label>
                    <input type="file" className="form-control" id="img" onChange={getSelectedImg}/>
                    <img src="" id="courseImg" style={{width: "15vw", "height": "15vw", "margin": "1vh 1vw"}}/>
                </div>
    
                <button className="btn btn-primary" onClick={saveCourse}>Uložit změny</button>
                <p style={{margin: "2vh"}}>{err}</p>

        </div>
        <div className="tab-pane fade" id="participants" role="tabpanel" aria-labelledby="participants-tab">
            <h4>Účastníci</h4>
            <p>Seznam účastníků kroužku.</p>
            {selectedCourse && selectedCourse.signedInStudents?.length ? <>
                <ul>{selectedCourse.signedInStudents.map((s) => {
                    return <li>{s.name + " " + s.surname}</li>
                })}</ul></> : <>
                <p>Žadní studenti nejsou ještě přihlášeni</p>
                </>
            }
            
        </div>
    </div>
</div>

        </>
     );
}

export default CourseDetailsPage;